import { useCallback } from 'react';
import useAxios from '@Apis/useAxios';
import {
    GET_DEVICE_ORDER_TASKS_OVERVIEW_OPTIONS_API,
    GET_DEVICE_ORDER_TASKS_OVERVIEW_API,
    GET_DEVICE_ORDER_TASKS_API,
    DELETE_DEVICE_ORDER_TASKS_API,
    POST_DEVICE_ORDER_TASKS_SETTLE_API,
    POST_DEVICE_ORDER_TASKS_EXPORT_API,
} from '@Apis/apiPath';

const UseDeviceOrderApi = () => {
    const Axios = useAxios();

    const getDeviceOrderTasksOverviewOptionsApi = useCallback(
        async () => {
            return await Axios.get(GET_DEVICE_ORDER_TASKS_OVERVIEW_OPTIONS_API);
        },
        // eslint-disable-next-line
        [],
    );

    const getDeviceOrderTasksOverviewApi = useCallback(
        async (params) => {
            return await Axios.get(GET_DEVICE_ORDER_TASKS_OVERVIEW_API, params);
        },
        // eslint-disable-next-line
        [],
    );

    const getDeviceOrderTasksApi = useCallback(
        async (taskID) => {
            return await Axios.get(GET_DEVICE_ORDER_TASKS_API(taskID));
        },
        // eslint-disable-next-line
        [],
    );

    const deleteDeviceOrderTasksApi = useCallback(
        async (taskID) => {
            return await Axios.delete(DELETE_DEVICE_ORDER_TASKS_API(taskID));
        },
        // eslint-disable-next-line
        [],
    );

    const postDeviceOrderTasksSettleApi = useCallback(
        async (taskID) => {
            return await Axios.post(POST_DEVICE_ORDER_TASKS_SETTLE_API(taskID));
        },
        // eslint-disable-next-line
        [],
    );

    const postDeviceOrderTasksExportApi = useCallback(
        async (taskID) => {
            return await Axios.post(POST_DEVICE_ORDER_TASKS_EXPORT_API(taskID));
        },
        // eslint-disable-next-line
        [],
    );

    return {
        getDeviceOrderTasksOverviewOptionsApi,
        getDeviceOrderTasksOverviewApi,
        getDeviceOrderTasksApi,
        deleteDeviceOrderTasksApi,
        postDeviceOrderTasksSettleApi,
        postDeviceOrderTasksExportApi,
    };
};

export default UseDeviceOrderApi;
